import Vue from "vue";
import type { ModuleTree } from "vuex";
import Vuex from "vuex";

Vue.use(Vuex);

interface ModuleState {}

export interface RootState {}

import documents from "./modules/documents";
import home from "./modules/home";
import remainings from "./modules/remainings";
import setting from "./modules/setting";
import seminars from "./modules/seminars";
import courses from "./modules/courses";
import card from "./modules/card";
import products from "./modules/products";
import profile from "./modules/profile";
import system from "./modules/system";
import favorites from "./modules/favorites";
import popups from "./modules/popups";
import order from "./modules/order";
import basket from "./modules/basket";
import metodist from "./modules/metodist";
import auth from "./modules/auth";
import search from "./modules/search";
import pages from "./modules/pages";
import managers from "./modules/managers";
import promotions from "./modules/promotions";
import brands from "./modules/brands";
import guides from "./modules/guides"
import pigmentCode from "./modules/pigmentCode"
import cosmobase from "./modules/cosmobase";
import comments from "@/store/modules/comments";
import feedbacks from "@/store/modules/feedbacks";
import beforeAfter from "@/store/modules/beforeAfter";
import proAge from "@/store/modules/proAge";
import catalog from "@/store/modules/catalog";

const modules: ModuleTree<ModuleState> = {
  documents,
  home,
  remainings,
  setting,
  seminars,
  courses,
  card,
  products,
  profile,
  system,
  favorites,
  popups,
  order,
  basket,
  metodist,
  auth,
  search,
  pages,
  managers,
  promotions,
  brands,
  guides,
  pigmentCode,
  cosmobase,
  comments,
  feedbacks,
  beforeAfter,
  proAge,
  catalog,
};

const store = new Vuex.Store({
  modules,
});

// @ts-ignore
export default store;
